import React from "react";
import "./NotFound.css";

import logo from "../../assets/img/logo-500.png";

const NotFound = () => {
  return (
    <div className="login-page">
      {/* background grid */}
      <div className="grid-bg" aria-hidden="true" />

      <div className="login-card" role="main">
        {/* Logo */}
        <div className="login-logo-wrap">
          <img src={logo} alt="Excel MEC" className="login-logo" />
        </div>

        {/* Heading */}
        <span className="login-kicker">Error 404</span>
        <h1 className="login-title">
          <strong>Page Not Found</strong>
        </h1>
        <p className="login-sub">
          The page you're looking for doesn't exist or has moved.
        </p>

        <a href="/" className="btn btn--primary btn--lg btn--block">
          Back to Dashboard
        </a>
      </div>
    </div>
  );
};

export default NotFound;
